import { Outlet } from 'react-router';

export const ImpersonateLayout = () => <Outlet />;
